import React from 'react';
import { OTPublisher } from 'opentok-react';

class Publisher extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         error: null,
         audio: true,
         video: true,
         videoSource: 'camera'
      };
      this.publisherEventHandlers = {
         destroyed: event => {
            const { onChangePublisherConnection } = this.props
            onChangePublisherConnection(false)
            console.log('LOG- PUBLISHER - Destroyed', event)
         },
      };
      this.setAudio = this.setAudio.bind(this)
      this.setVideo = this.setVideo.bind(this)
      this.changeVideoSource = this.changeVideoSource.bind(this)
      this.onError = this.onError.bind(this)
      this.onInit = this.onInit.bind(this)
      this.onPublish = this.onPublish.bind(this)
      this.getPublisherStyle = this.getPublisherStyle.bind(this)
   }

   setAudio(audio) {
      this.setState({ audio });
   }

   setVideo(video) {
      this.setState({ video });
   }

   changeVideoSource(videoSource) {
      (this.state.videoSource !== 'camera') ? this.setState({ videoSource: 'camera' }) : this.setState({ videoSource: 'screen' })
   }

   onError(err) {
      // console.log("Publisher error")
      // this.setState({ error: `Failed to publish: ${err.message}` });
   }

   onInit() {
      // console.log("Publi:sher Init")
   }

   onPublish() {
      // console.log("Publisher Publish")
   }

   componentWillMount() {
      const { changePublisherStatus } = this.props
      changePublisherStatus(true)
   }
   componentWillUnmount() {
      const { changePublisherStatus } = this.props
      changePublisherStatus(false)
   }

   getPublisherStyle() {
      const { isSubscriber, publisherConnected } = this.props
      let borderColor = publisherConnected ? 'rgb(29,159,173)' : 'rgb(238,141,35)'
      let publisherStyle = {}
      if (!isSubscriber) {
         publisherStyle = {
            className: 'SmallPublisher',
            style: {
               border: `5px solid ${borderColor}`,
               borderRadius: '10px',
               top: 0,
               left: 0,
               width: 'calc(100% - 10px)',
               height: 'calc(100% - 10px)',
               position: 'absolute'
            }
         }
      } else {
         publisherStyle = {
            className: 'BigPublisher',
            style: {
               border: `2px solid ${borderColor}`,
               borderRadius: '10px',
               top: 10,
               right: 10,
               width: '60px',
               height: '120px',
               position: 'absolute',
               zIndex: 2
            }
         }
      }
      return publisherStyle
   }

   render() {
      const { appointment, publisherAudio, publisherVideo } = this.props
      const publisherStyle = this.getPublisherStyle()
      return (
         <div className="publisher">
            <OTPublisher {...publisherStyle}
               session={this.props.session}
               properties={{
                  publishAudio: publisherAudio,
                  publishVideo: publisherVideo,
                  videoSource: this.state.videoSource === 'screen' ? 'screen' : undefined,
                  name: appointment.clientFullName,
                  style: {
                     buttonDisplayMode: 'off',
                     nameDisplayMode: 'on'
                  }
               }}
               eventHandlers={this.publisherEventHandlers}
               onError={this.onError}
               onInit={this.onInit}
               onPublish={this.onPublish}
            />
         </div>
      );
   }
}
export default Publisher;



// WEBPACK FOOTER //
// ./src/containers/TeleHealthVideo/tokboxComponents/Publisher.js